export default {
  url: {
    frontend: `#{account}.${process.env.REACT_APP_FRONTEND_WEB_APP_DOMAIN}`,
    backend: `#{account}.${process.env.REACT_APP_BACKEND_WEB_APP_DOMAIN}`
  },
  /**
   * Backend base URL. When `REACT_APP_BACKEND_SUBDOMAIN` is empty, `REACT_APP_BACKEND_WEB_APP_DOMAIN`
   * is treated as the full host (e.g. `localhost:5000` for local API). Otherwise: `{sub}.{domain}`.
   */
  getBackendAppURL(isAddSlashes = false, httpProtocol = false, endpoint = "") {
    const account = (process.env.REACT_APP_BACKEND_SUBDOMAIN || "").trim();
    const domain = (process.env.REACT_APP_BACKEND_WEB_APP_DOMAIN || "").trim();
    const host = account ? `${account}.${domain}` : domain;

    let backendURL = (httpProtocol === true) ? process.env.REACT_APP_BACKEND_HTTP_PROTOCOL : "";
    backendURL += isAddSlashes ? "//" : "";
    backendURL += host;
    backendURL += endpoint || "";

    return backendURL;
  },
  getFrontendAppURL(isAddSlashes = false, httpProtocol = false, endpoint = "", port = true) {

    let frontURL = (httpProtocol === true) ? process.env.REACT_APP_FRONTEND_HTTP_PROTOCOL : "";
    frontURL += isAddSlashes ? "//" : "";
    frontURL += this.url.frontend.replace("#{account}", process.env.REACT_APP_FRONTEND_SUBDOMAIN);
    frontURL += process.env.REACT_APP_FRONTEND_DOMAIN_PORT;
    frontURL += endpoint;

    return frontURL;
  },
  store_name: (process.env.REACT_APP_REDUX_STORE || "funnel-store"),
  getAuthPortalUrl() {
    return (process.env.REACT_APP_AUTH_PORTAL_URL || "").trim();
  },
  getMsalInteractionMode() {
    const raw = (process.env.REACT_APP_MSAL_INTERACTION_MODE || "redirect").trim().toLowerCase();
    return raw === "popup" ? "popup" : "redirect";
  }
};
